module.exports = __webpack_public_path__ + "img/930-4941b3.png";